import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function FloatingCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const testimonialsSection = document.getElementById('video-testimonials-section');
      const ofertaSection = document.getElementById('oferta-conviccion');
      if (!testimonialsSection) return;
      const rect = testimonialsSection.getBoundingClientRect();
      // Show button once the video testimonials section is scrolled past (bottom is above viewport)
      const pastSection = rect.bottom < 0;
      // Hide if user is already at the offer section
      let atOffer = false;
      if (ofertaSection) {
        const ofertaRect = ofertaSection.getBoundingClientRect();
        atOffer = ofertaRect.top < window.innerHeight && ofertaRect.bottom > 0;
      }
      setIsVisible(pastSection && !atOffer);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToOffer = () => {
    const oferta = document.getElementById('oferta-conviccion');
    if (oferta) {
      oferta.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  };
  return <AnimatePresence data-id="element-141">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      damping: 25,
      stiffness: 300
    }} className="fixed bottom-5 left-1/2 -translate-x-1/2 z-[9999] w-[calc(100%-2rem)] max-w-md" data-id="element-142">
          <button onClick={scrollToOffer} className="floating-cta-pulse w-full bg-[#22C55E] hover:bg-[#1DB954] text-white font-black py-4 px-6 rounded-2xl cursor-pointer shadow-[0_8px_30px_rgba(34,197,94,0.5)] flex flex-col items-center gap-0.5 border-2 border-white/20 transition-colors" data-id="element-143">
            <span className="text-[17px] md:text-[19px] uppercase tracking-wide" data-id="element-144">
              SÍ, QUIERO GANAR MÁS COMO ELECTRICISTA
            </span>
            <span className="text-[11px] md:text-[12px] font-semibold opacity-90" data-id="element-145">
              Acceso Inmediato • Garantía de 7 Días
            </span>
          </button>
        </motion.div>}
    </AnimatePresence>;
}